import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { GetAccessToken } from '../auth/AuthService';
import { GetAppSettings } from '../AppSettings';
import { safeConcatUrl } from '../helpers/api';

let connection = null;

export function CreateConnection() {
  const appSettings = GetAppSettings();
  connection = new HubConnectionBuilder()
    .withUrl(safeConcatUrl(appSettings.NotificationServiceUrl, `notificationHub/${appSettings.Environment.toLowerCase()}`), {
      accessTokenFactory: () => {
        const accessToken = GetAccessToken();
        return accessToken;
      }
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Information)
    .build();

  return connection;
}

export function GetConnection() {
  return connection;
}
